module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place column"
  }, [_c('div', {
    staticClass: "take-place from-start column"
  }, [_c('div', {
    staticClass: "heading-sub-client-container"
  }, [_c('div', {
    staticClass: "heading-sub-client row start"
  }, [_c('router-link', {
    staticClass: "btn-icon",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.client.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "level take-place"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Agrégation manuel de "), _c('span', [_vm._v(_vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('router-link', {
    staticClass: "btn btn-red ctn-icon",
    attrs: {
      "to": {
        name: 'InvestmentsManualAdd'
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-new-mission"
  }), _vm._v("\n\t\t\t\t\t\t\tNouveau produit\n\t\t\t\t\t\t")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "master-investments master-investments-manual"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\tProduits\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-several row"
  }, [_c('div', {
    staticClass: "white-box with-tags with-array take-place"
  }, [_c('div', {
    staticClass: "ctn-table ctn-section-table row"
  }, [_c('section-table', {
    attrs: {
      "columns": _vm.cols,
      "rows": _vm.rows
    },
    on: {
      "action-item-clicked": _vm.onActionItemClicked
    }
  })], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64b4730a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/InvestmentsManual/InvestmentsManual.vue
// module id = 1140
// module chunks = 0